import type { UserRoleDto } from "@/api/types";
import type { TranslationFunction, Translations } from "@/translations";

export const getRoleLabelByType = (t: TranslationFunction<Translations>, type: UserRoleDto["type"]): string => {
  switch (type) {
    case "resident":
      return t("model.role.type.resident");
    case "projectOwner":
      return t("model.role.type.project-owner");
    case "projectAdmin":
      return t("model.role.type.project-admin");
    case "readOnly":
      return t("model.role.type.readOnly");
    case "maintenance":
      return t("model.role.type.maintenance");
    case "caretaker":
      return t("model.role.type.caretaker");
    case "servicePartner":
      return t("model.role.type.service-partner");
    default:
      console.error(`Unknown user role type "${type}"`);

      return "";
  }
};

export const USER_ROLE_TYPES = [
  "projectAdmin",
  "projectOwner",
  "readOnly",
  "maintenance",
  "caretaker",
  "servicePartner",
  "resident",
] as const satisfies UserRoleDto["type"][];

export const ADMIN_USER_ROLE_TYPES = USER_ROLE_TYPES.filter((type) => type !== "resident");
